module.exports = __webpack_public_path__ + "assets/media/msg-bell.892b3a1f.mp3";